import React from 'react'
import Feature1 from "../../assets/images/secure.png"
import Step2 from "../../assets/images/step2.png"
import Step3 from "../../assets/images/step3.png"
import Support from "../../assets/images/abt_support.png"
import Frame from "../../assets/images/features_frame.png"

function Features() {
    return (
        <>
            <section className="row_am features_section features-video" id="features">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
                        <h2><span>Features</span> that makes app different!</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typese tting <br /> indus orem Ipsum has beenthe
                            standard dummy.</p>
                    </div>
                    <div className="feature_detail">
                        <div className="left_data feature_box">
                            <div className="data_block block1" data-aos="fade-right" data-aos-duration="1500">
                                <div className="icon">
                                    <img src={Feature1} alt="image" />
                                </div>
                                <div className="text">
                                    <h4>Secure data</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and type setting indus ideas.</p>
                                </div>
                            </div>

                            <div className="data_block block2" data-aos="fade-right" data-aos-duration="1500">
                                <div className="icon">
                                    <img src={Step2} alt="image" />
                                </div>
                                <div className="text">
                                    <h4>Fully functional</h4>
                                    <p>Simply dummy text of the printing and typesetting indus lorem Ipsum is dummy.</p>
                                </div>
                            </div>
                        </div>

                        <div className="right_data feature_box">
                            <div className="data_block block3" data-aos="fade-left" data-aos-duration="1500">
                                <div className="icon">
                                    <img src={Step3} alt="image" />
                                </div>
                                <div className="text">
                                    <h4>Live chat</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and type setting indus ideas.</p>
                                </div>
                            </div>

                            <div className="data_block block4" data-aos="fade-left" data-aos-duration="1500">
                                <div className="icon">
                                    <img src={Support} alt="image" />
                                </div>
                                <div className="text">
                                    <h4>24-7 Support</h4>
                                    <p>Simply dummy text of the printing and typesetting indus lorem Ipsum is dummy.</p>
                                </div>
                            </div>

                        </div>
                        <div className="feature_img" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
                            <img src={Frame} alt="image" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Features